export const getRandomData = (length = 10, rangeStart = 1000, rangeStop = 10000) => {
  let retArr = [];
  for (let i = 0; i < length; i++) {
    retArr.push(Math.floor(Math.random() * rangeStop) + rangeStart);
  }
  return retArr;
};

export const getDateArr = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  let datesArr = [];
  while (start <= end) {
    datesArr.push(start.toISOString().split("T")[0]);
    start.setDate(start.getDate() + 1);
  }
  return datesArr;
};

export const getCountryName = (countryCode) => {
  let countryCodeMapping = {
    "BGD": "Bangladesh",
    "IN": "India",
    "JP": "Japan",
    "SG": "Singapore",
    "SL1": "Srilanka (Softlogic)",
    "SL2": "Srilanka (Damro)",
    "SL3": "Srilanka (Singer)",
    "TH": "Thailand",
    "NP": "Nepal"
  }

  if (countryCodeMapping.hasOwnProperty(countryCode)) {
    return countryCodeMapping[countryCode]
  }

  return countryCode
}

export const getCountryCodeISO = (countryCode) => {
  let countryCodeISOMapping = {
    "BD": "BGD",
    "IN": "IND",
    "JP": "JPN",
    "SG": "SGP",
    "SL1": "LKA",
    "SL2": "LKA",
    "SL3": "LKA",
    "TH": "THA",
    "NP": "NPL",
    "LK": "LKA"
  }

  if (countryCodeISOMapping.hasOwnProperty(countryCode)) {
    return countryCodeISOMapping[countryCode]
  }

  return null
}

export const getFormatedJSON = (data) => {
  return <pre>
    <code>
      {JSON.stringify(data, null, 4)}
    </code>
  </pre>
}

export const formatTableHeader = (header) => {
  //formatting based on _
  // const formattedHeader = header?.split("_")?.map(h => capitalize(h)?.join(" "))
  //formmatting based on capital letters
  // const formattedHeader = header?.split(/(?=[A-Z])/)?.join(" ")
  //add code is formatting of header is required
  return header;
}

export const getACDeviceStatusKeyMap = (key) => {
  const deviceStatusKeyMap = {
    acmd: "AC Mode",
    acfs: "Fan Speed",
    acfc: "Fan Controller",
    acdl: "Filter Dust Level",
    acsp: "Sleep Profile",
    acvs: "Vertical Swing",
    achs: "Horizontal Swing",
    actm: "Timer",
    ps: "Power Status",
    actmp: "Temperature (ºC)",
    acdc: "Display Control",
    acec: "Evaporator Clean",
    acng: "Nanoe GA",
    acpms: "PM2.5 Sensor",
    acpm: "Powerful Mode",
    rssi: "WiFi Strength",
    rmtmp: "Room Temperature (ºC)",
    acms: "Eco Navi",
    acmss: "Motion Sensor Status",
    acfh: "Time-based Filter Health",
    cnv: "Convertible Mode",
    mo: "Model ID",
    ty: "Device Type",
    ts: "Time Stamp"
  };

  return deviceStatusKeyMap[key] || key;
}

export function validatePassword(password) {
  const minLength = 8;
  const hasUppercase = /[A-Z]/.test(password);
  const hasNumber    = /\d/.test(password);
  const hasSpecial   = /[^A-Za-z0-9]/.test(password);

  if (password.length < minLength) {
    return { valid: false, error: `Password must be at least ${minLength} characters.` };
  }
  if (!hasUppercase) {
    return { valid: false, error: "Password must include at least one uppercase letter." };
  }
  if (!hasNumber) {
    return { valid: false, error: "Password must include at least one number." };
  }
  if (!hasSpecial) {
    return { valid: false, error: "Password must include at least one special character." };
  }
  return { valid: true };
}

export function normalizeTimestamp(timestamp) {
  if (!timestamp) return null;
  const ts = Number(timestamp);
  if (ts.toString().length === 10) {
    return ts * 1000;
  }
  return ts;
};

export const AllowedConversionType = {
  current_based: "Current Based",
  frequency_based: "Frequency Based"
}

export function convertCapabilityName(capabilityName) {
  return capabilityName.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2').trim();
}

export const MAX_POSITIVE_INT = Number.MAX_SAFE_INTEGER;
export const MAX_POSITIVE_INT_LENGTH = String(MAX_POSITIVE_INT).length;